import style from "./givingli-essence.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import InfoBlock from "../info-block/info-block";
import { IInfoBlock } from "../givingli.content";

type InfoBlockProps = {
    infoBlock: IInfoBlock;
}
const GivingliEssence = ({infoBlock}: InfoBlockProps) => {

    return (
        <SharedAnimation render={(ref) => (
            <section className={`${style.section} ${style.section__info}`}>
                <div className={style.section__title}>
                   {infoBlock.title}
                </div>
            <div className={`${style.container} ${style.container__info}`}>
                {infoBlock.blocks.map((item: any, index: number) => {
                    return <InfoBlock key={index} state={item}/>
                })}
            </div>
        </section>
        )}/>
    );
}

export default GivingliEssence;